// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3F4Qj","colCheckbox":"styles_colCheckbox__11lJQ"};